//import "./wdyr";
import dayjs from "dayjs";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import localizedFormat from "dayjs/plugin/localizedFormat";
import utc from "dayjs/plugin/utc";
import "dayjs/locale/en";
import { registerComponents } from "./componentRegistry";
import "./styles/style_vendor.less";
import "./styles/style.less";
import { createInitialHashScroller } from "~/common/createInitialHashScroller";
import { bindLmsLinkListener } from "~/features/lms/LmsLinkListener";
import { startZoovuTracking } from "~/app/analytics/zoovu/zoovuTracking";
import "~/app/analytics";

import { LicenseInfo } from "@mui/x-license";
LicenseInfo.setLicenseKey(
  "80035531017802fcf9a758e1079b8621Tz0xMjAxOTQsRT0xNzkxNTkwMzk5MDAwLFM9cHJvLExNPXBlcnBldHVhbCxQVj1RMy0yMDI0LEtWPTI=",
);

dayjs.extend(utc);
dayjs.extend(isSameOrBefore);
dayjs.extend(localizedFormat);
dayjs.locale({ ...dayjs.Ls.en, weekStart: 1 });

// Based on the sourcecode of react-google-recaptcha/src/recaptcha-wrapper.js we can set a dynamic configuration to use recaptcha.net instead of google
// eslint-disable-next-line @typescript-eslint/no-explicit-any
(window as any).recaptchaOptions = {
  useRecaptchaNet: true,
};

registerComponents();

window.SCHA.markReactReady();

// page is hidden until react loads
Array.from(document.querySelectorAll(".js__hidden-until-react")).forEach((el) => el.classList.add("react-loaded"));

window.addEventListener("load", () => {
  if (window.SCHA.config.isZoovuTrackingEnabled) {
    startZoovuTracking();
  }
});

createInitialHashScroller();

bindLmsLinkListener();
